import { default as WscIconAddReplay } from "./AddReplay";
import { default as WscIconAddShortcut } from "./AddShortcut";
import { default as WscIconAISearch } from "./AISearch";
import { default as WscIconAuto } from "./Auto";
import { default as WscIconAutoLink } from "./AutoLink";
import { default as WscIconBook } from "./Book";
import { default as WscIconChainedEvent } from "./ChainedEvent";
import { default as WscIconChild } from "./Child";
import { default as WscIconColorSwatch } from "./ColorSwatch";
import { default as WscIconConvertEe } from "./ConvertEe";
import { default as WscIconDispatch } from "./Dispatch";
import { default as WscIconDuplicate } from "./Duplicate";
import { default as WscIconEditTime } from "./EditTime";
import { default as WscIconEmojiUnFlags } from "./EmojiUnFlags";
import { default as WscIconErrowNotification } from "./ErrowNotification";
import { default as WscIconFlipHorizontal } from "./FlipHorizontal";
import { default as WscIconFlipVertical } from "./FlipVertical";
import { default as WscIconInProgress } from "./InProgress";
import { default as WscIconKeepOut } from "./KeepOut";
import { default as WscIconLegend } from "./Legend";
import { default as WscIconLowest } from "./Lowest";
import { default as WscIconMagicCrop } from "./MagicCrop";
import { default as WscIconTextToVideo } from "./TextToVideo";
import { default as WscIconManual } from "./Manual";
import { default as WscIconMaster } from "./Master";
import { default as WscIconMoveEvent } from "./MoveEvent";
import { default as WscIconMusicRights } from "./MusicRights";
import { default as WscIconMxf } from "./Mxf";
import { default as WscIconOpenNew } from "./OpenNew";
import { default as WscIconPaste } from "./Paste";
import { default as WscIconProviderMapper } from "./ProviderMapper";
import { default as WscIconShare } from "./Share";
import { default as WscIconShowIn } from "./ShowIn";
import { default as WscIconSnap } from "./Snap";
import { default as WscIconSubmaster } from "./Submaster";
import { default as WscIconToggleViewPanel } from "./ToggleViewPanel";
import { default as WscIconUnchainedEvent } from "./UnchainedEvent";
import { default as WscIconUnpin } from "./Unpin";
import { default as WscIconUnrecess } from "./Unrecess";
import { default as WscIconUnsnap } from "./Unsnap";
import { default as WscIconUnSync } from "./UnSync";
import { default as WscIconZip } from "./Zip";
import { default as WscIconSettings } from "./Settings";
import { default as WscIconShortcut } from "./Shortcut";

const icons = {
  WscIconAddReplay,
  WscIconAddShortcut,
  WscIconAISearch,
  WscIconAuto,
  WscIconAutoLink,
  WscIconBook,
  WscIconChainedEvent,
  WscIconChild,
  WscIconColorSwatch,
  WscIconConvertEe,
  WscIconDispatch,
  WscIconDuplicate,
  WscIconEditTime,
  WscIconEmojiUnFlags,
  WscIconErrowNotification,
  WscIconFlipHorizontal,
  WscIconFlipVertical,
  WscIconInProgress,
  WscIconKeepOut,
  WscIconLegend,
  WscIconLowest,
  WscIconMagicCrop,
  WscIconTextToVideo,
  WscIconManual,
  WscIconMaster,
  WscIconMoveEvent,
  WscIconMusicRights,
  WscIconMxf,
  WscIconOpenNew,
  WscIconPaste,
  WscIconProviderMapper,
  WscIconShare,
  WscIconShowIn,
  WscIconSnap,
  WscIconSubmaster,
  WscIconToggleViewPanel,
  WscIconUnchainedEvent,
  WscIconUnpin,
  WscIconUnrecess,
  WscIconUnsnap,
  WscIconUnSync,
  WscIconZip,
  WscIconSettings,
  WscIconShortcut,
};

export default icons;
